module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/Battle/images/bg-sortie.93b9e6c2.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Battle/images/bg-sortie.png
// module id = 2503
// module chunks = 11